import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const TrainStationIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "TrainStationIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M15.8843 18.3647H8.11572C6.13476 18.3647 4.52295 16.7529 4.52295 14.772V5.58789C4.52295 3.60693 6.13477 1.99512 8.11572 1.99512H15.8843C17.8652 1.99512 19.477 3.60694 19.477 5.58789V14.772C19.477 16.7529 17.8652 18.3647 15.8843 18.3647ZM8.11571 2.99512C6.68602 2.99512 5.52294 4.15821 5.52294 5.58789V14.772C5.52294 16.2017 6.68603 17.3647 8.11571 17.3647H15.8843C17.3139 17.3647 18.477 16.2016 18.477 14.772V5.58789C18.477 4.1582 17.3139 2.99512 15.8843 2.99512H8.11571Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M6.05468 22.0049C5.96728 22.0049 5.87841 21.9819 5.79784 21.9336C5.56102 21.7915 5.48436 21.4844 5.62645 21.2476L7.80907 17.6074C7.95116 17.3706 8.25731 17.2939 8.49511 17.436C8.73193 17.5781 8.80859 17.8852 8.6665 18.1221L6.48388 21.7622C6.39013 21.9185 6.2246 22.0049 6.05468 22.0049Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M17.9453 22.0049C17.7754 22.0049 17.6098 21.9185 17.5161 21.7622L15.3335 18.1221C15.1914 17.8852 15.268 17.5781 15.5049 17.436C15.7412 17.2939 16.0493 17.3706 16.1909 17.6074L18.3735 21.2476C18.5156 21.4844 18.439 21.7915 18.2021 21.9336C18.1216 21.9819 18.0327 22.0049 17.9453 22.0049Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M17.0766 20.6899H6.96532C6.68895 20.6899 6.46532 20.4663 6.46532 20.1899C6.46532 19.9136 6.68895 19.6899 6.96532 19.6899H17.0766C17.353 19.6899 17.5766 19.9136 17.5766 20.1899C17.5766 20.4663 17.353 20.6899 17.0766 20.6899Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M18.9263 6.02832H5.07372C4.79735 6.02832 4.57372 5.80469 4.57372 5.52832C4.57372 5.25195 4.79735 5.02832 5.07372 5.02832H18.9263C19.2026 5.02832 19.4263 5.25195 19.4263 5.52832C19.4263 5.80469 19.2026 6.02832 18.9263 6.02832Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M18.9263 11.3877H5.07372C4.79735 11.3877 4.57372 11.1641 4.57372 10.8877C4.57372 10.6113 4.79735 10.3877 5.07372 10.3877H18.9263C19.2026 10.3877 19.4263 10.6113 19.4263 10.8877C19.4263 11.1641 19.2026 11.3877 18.9263 11.3877Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M12 11.3877C11.7236 11.3877 11.5 11.1641 11.5 10.8877V5.52832C11.5 5.25195 11.7236 5.02832 12 5.02832C12.2764 5.02832 12.5 5.25195 12.5 5.52832V10.8877C12.5 11.1641 12.2764 11.3877 12 11.3877Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M8.562 16.1401C7.56151 16.1401 6.74755 15.3262 6.74755 14.3257C6.74755 13.3252 7.56151 12.5112 8.562 12.5112C9.56249 12.5112 10.3764 13.3252 10.3764 14.3257C10.3764 15.3262 9.56249 16.1401 8.562 16.1401ZM8.562 13.5112C8.11278 13.5112 7.74755 13.8765 7.74755 14.3257C7.74755 14.7749 8.11278 15.1401 8.562 15.1401C9.01122 15.1401 9.37645 14.7749 9.37645 14.3257C9.37645 13.8765 9.01122 13.5112 8.562 13.5112Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M15.438 16.1401C14.4375 16.1401 13.6235 15.3262 13.6235 14.3257C13.6235 13.3252 14.4375 12.5112 15.438 12.5112C16.4385 12.5112 17.2524 13.3252 17.2524 14.3257C17.2524 15.3262 16.4385 16.1401 15.438 16.1401ZM15.438 13.5112C14.9888 13.5112 14.6235 13.8765 14.6235 14.3257C14.6235 14.7749 14.9888 15.1401 15.438 15.1401C15.8872 15.1401 16.2524 14.7749 16.2524 14.3257C16.2524 13.8765 15.8872 13.5112 15.438 13.5112Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default TrainStationIcon;
